import { render, staticRenderFns } from "./read-jianyanzu.vue?vue&type=template&id=7f5745e4&scoped=true"
import script from "./read-jianyanzu.vue?vue&type=script&lang=ts"
export * from "./read-jianyanzu.vue?vue&type=script&lang=ts"
import style0 from "./read-jianyanzu.vue?vue&type=style&index=0&id=7f5745e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5745e4",
  null
  
)

export default component.exports